module.exports = __webpack_public_path__ + "static/media/5msp.ac9e9203.pdf";